import React from "react";
import "../../../css/TotalSubsc.css";
import mobility from "../../../img/ride.png";

interface TotalSubscProps {
  TotalSubsc: number;
}

const TotalSubsc = ({ TotalSubsc }: TotalSubscProps) => {
  return (
    <div className="subsc_amount_container">
      <div className="subsc_display">
        <img className="mobility" src={mobility} />
        <div className="subsc_amount_title">累計登録者数</div>
      </div>
      <div className="subsc_amount_of">
        {TotalSubsc}
        <span className="unit">人</span>
      </div>
    </div>
  );
};

export default TotalSubsc;
